import styled, { css } from 'styled-components';
import { fillAbsolute } from '../../../theme/mixins';
import { LazyLoadImage } from '../lazyLoadImage';
import { LazyLoadVideo } from '../lazyLoadVideo';

export const Image = styled(LazyLoadImage).attrs(() => ({
  disableRatioCalculation: true,
  imgStyle: css`
    height: 100%;
    background-position: center;
    object-fit: cover;
  `,
  placeholderStyle: css`
    ${fillAbsolute};
  `,
}))`
  ${fillAbsolute};
`;

export const Video = styled(LazyLoadVideo)`
  ${fillAbsolute};
  width: auto;
  min-width: 100%;
`;
